import { useEffect } from "react";
import { useParams } from "wouter";
import { beginSSOLogin } from "../auth/ssoRoutes";
import { Spinner } from "../components/AsyncStates";
import "./login.css";

/**
 * The distributed-deep-link landing spot (ADR-0037 §UX): `/t/{slug}/sso` is
 * what an organization hands out as ITS sign-in link — unlike the org-slug
 * step on `LoginPage`, the slug is already known, so this skips straight to
 * the real browser navigation with no prompt. It is deliberately a PUBLIC
 * route (mounted outside `ProtectedRoute` in App.tsx, same as `/login`) since
 * whoever clicks it is, by definition, not signed in yet.
 *
 * This is a real client-side SPA route only so an unauthenticated visitor's
 * browser has SOMETHING to render for the instant before the outbound
 * navigation fires — it never stays mounted long enough to need a fuller
 * page.
 */
export function SSORedirectPage() {
  const { slug } = useParams<{ slug: string }>();

  useEffect(() => {
    if (!slug) return;
    beginSSOLogin(slug);
  }, [slug]);

  return (
    <div className="login">
      <div className="login__card">
        <div className="login__brand">
          <span className="login__brand-mark" aria-hidden="true" />
          <span className="login__brand-name">Comebye</span>
        </div>
        <p className="login__subtitle">
          <Spinner label="Redirecting to your organization's sign-in…" /> Redirecting to your organization's sign-in…
        </p>
      </div>
    </div>
  );
}
